import React, { useState } from "react";
import LottoRowEditor from "../rows/LottoRowEditor";
import GameType from "../../data/GameType";
import EditorNumber from "../numbers/EditorNumber";
import { useTranslation } from 'react-i18next';
import GameHeader from "../GameHeader";
import GameStartButtons from "../GameStartButtons";
import { useLoaderData, useNavigate, useSearchParams } from "react-router-dom";
import NumbersUtil from "../../util/NumbersUtil";
import localDao from "../../data/localDao";
import AddToCart from "../AddToCart";
import shuffleIcon from '../../icons/shuffle.svg';
import trashIcon from '../../icons/trash.svg';
import DrawCountSelector from "../DrawCountSelector";
import ExpandArrow from "../buttons/ExpandArrow";

const Bingo = (props) => {
    const { t } = useTranslation();
    const game = useLoaderData();
    const [rows, setRows] = useState(game?.rows || props.game?.rows || []);
    const [isOpen] = useState(props.isOpen || false);
    const [isExpanded, setIsExpanded] = useState(props.isExpanded || false);
    const [drawCount, setDrawCount] = useState(game?.drawCount || props.game?.drawCount || 1);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    if (rows.length < 1 && searchParams.size > 0 && !searchParams.get("utm_source")) {
        let row;
        if (searchParams.get("initialData") === "random") {
            row = NumbersUtil.randomBingo();
        } else {
            row = GameType.BINGO.emptyRow();
        }
        row.editorOpen = true;
        setRows([row]);
    }
    const incrementSelectedPosition = (row) => {
        //never incement from last position
        if (row.selectedPosition.x === 4 && row.selectedPosition.y === 4) {
            return;
        }
        //dont increment when position is empty
        if (!row.numbers[row.selectedPosition.x][row.selectedPosition.y]) {
            return;
        }
        if (row.selectedPosition.y === 4) {
            row.selectedPosition.x += 1;
            row.selectedPosition.y = 0;
        } else {
            row.selectedPosition.y +=1;
        }
    };
    const toggleNumber = (row, number) => {
        if (row.numbers[row.selectedPosition.x][row.selectedPosition.y] === number) {
            row.numbers[row.selectedPosition.x][row.selectedPosition.y] = null;
        } else if (row.numbers[row.selectedPosition.x].includes(number)) {
            var i = row.numbers[row.selectedPosition.x].indexOf(number);
            row.numbers[row.selectedPosition.x][i] = null;
            row.numbers[row.selectedPosition.x][row.selectedPosition.y] = number;
        } else {
            row.numbers[row.selectedPosition.x][row.selectedPosition.y] = number;
        }
        return row;
    };
    const onClickNumber = (number, rowNr) => {
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result[rowNr] = toggleNumber(result[rowNr], number);
            incrementSelectedPosition(result[rowNr]);
            //console.log(result);
            return result;
        });
    };
    const saveGame = (newRows) => {
        localDao.saveGameToCart(GameType.BINGO, {stake: GameType.BINGO.stake, drawCount: drawCount, rows: newRows});
    };
    const deleteGame = () => {
        saveGame([]);
        setRows([]);
        props.onDeleteGame && props.onDeleteGame();
        navigate(process.env.PUBLIC_URL + "/");
    };
    const addRow = (ele) => {
        var position = JSON.parse(JSON.stringify(ele.target.offsetTop - 20));
        setTimeout(() => window.scrollTo({
            top: position,
            behavior: "smooth"
        }), 100);
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result.push(GameType.BINGO.emptyRow());
            return result;
        });
    };
    const deleteRow = (rowNr) => {
        setRows((prev) => {
            var result = [...prev];
            result.splice(rowNr, 1);
            return result;
        });
    };
    const shuffleRow = (rowNr) => {
        setRows((prev) => {
            var result = [...prev];
            result[rowNr] = NumbersUtil.randomBingo();
            return result;
        });
    };
    const addToCart = () => {
        saveGame(rows);
        navigate(process.env.PUBLIC_URL + "/");
    };
    const setSelectedPosition = (rowNr, position) => {
        setRows((prev) => {
            var result = JSON.parse(JSON.stringify(prev));
            result[rowNr].selectedPosition.x = position.x;
            result[rowNr].selectedPosition.y = position.y;
            return result;
        });
    };
    const toggleOpen = () => {
        navigate(process.env.PUBLIC_URL + "/game/" + GameType.BINGO.name);

    };
    const toggleRowEditor = (rowNr, isEditorOpen) => {
        setRows((prev) => {
            var result = [...prev];
            result[rowNr].editorOpen = isEditorOpen
            return result;
        });
    };
    const getUnfilledCount = (rowNr) => {
        var row = rows[rowNr];
        var result = 0;
        for (var i = 0; i < 5; i++) {
            result += 5 - row.numbers[i].filter((nr) => nr).length;
        }
        return result;
    };
    const getUnfilledText = (rowNr) => {
        return t('texts.chooseNumbers') + ' - ' + getUnfilledCount(rowNr) + ' ' + t('texts.more');
    };
    const createSelectableNumbers = (row, rowNr) => {
        var x = Number.parseInt(row.selectedPosition.x);
        var selectableNumbers = [x * 15 + 1, x * 15 + 15];
        return (
            <LottoRowEditor 
                onClickNumber={(number) => { onClickNumber(number, rowNr) }}
                column={x}
                selectableNumbers={selectableNumbers}
                row={row}
                gameType={GameType.BINGO}>
            </LottoRowEditor>
        );
    };
    const createBingoLetters = (row) => {
        return ['B', 'I', 'N', 'G', 'O'].map((letter, i) => {
            return (
                <EditorNumber
                    className={'bingoLetter ' + (i === row.selectedPosition.x ? 'bingoSelectedColumn' : '')}
                    key={letter}
                    number={letter}
                ></EditorNumber>
            );
        });
    };
    const createGrid = (row, rowNr) => {
        var result = [];
        result.push(createBingoLetters(row));
        for (var y = 0; y < 5; y++) {
            for (var x = 0; x < 5; x++) {
                result.push(
                    <EditorNumber
                        className={"bingoNumber square " + (x === row.selectedPosition.x ? 'bingoSelectedColumn' : '')}
                        key={y + "" + x}
                        number={row.numbers[x] && row.numbers[x][y]}
                        selected={x === row.selectedPosition.x && y === row.selectedPosition.y}
                        onClickNumber={setSelectedPosition.bind(this, rowNr, { y: y, x: x })}>
                    </EditorNumber>);
            }
        }
        return result;
    };
    const createRowHeader = (row, rowNr) => {
        return (
            <div className="flexGrow1">
                <ExpandArrow onToggleExpanded={(isEditorOpen) => toggleRowEditor(rowNr, isEditorOpen)} isExpanded={row.editorOpen}></ExpandArrow>
                <div className="flexCenter darkBlueBold15">{GameType.labels[rowNr]}</div>
                <div className="inlineFlex marginLeft1">{getUnfilledText(rowNr)}</div>
                <div className="inlineFlex flexEnd">
                    <div className='textCenter inlineFlex flexColumn marginRight1'>
                        <img alt='' src={shuffleIcon} onClick={() => shuffleRow(rowNr)}></img>
                {/*    <span className='smallText'>{t('button.pliksPlaks')}</span> */}
                </div>
                    <img alt='' src={trashIcon} onClick={() => deleteRow(rowNr)}></img>
                </div>
            </div>
        );
    };
    const createRowEditor = (row, rowNr) => {
        return (
            <>
                <div className="grid5 padding05">{createGrid(row, rowNr)}</div>
                <div className="lightGrey2Bg padding05 marginTop1">
                    <div className='marginLeft1 marginTop1'>{t('texts.chooseNumber')}</div>
                    {createSelectableNumbers(row, rowNr)}
                </div>
            </>
        );
    };
    const createRows = () => {
        return rows.map((row, rowNr) => {
            return (
                <div key={rowNr} className="bingoRow padding1 marginBottom1">
                    {createRowHeader(row, rowNr)}
                    <div className='afterBorder05'></div>
                    {row.editorOpen && createRowEditor(row, rowNr)}
                </div>
            );
        });
    };
    const calculatePrice = () => {
        var price = rows.length * drawCount * GameType.BINGO.stake / 100;
        return NumbersUtil.padPrice(price);
    };
    return (
        <div className={'game ' + (rows.length > 0 ? '' : 'empty ') + (isOpen ? 'open': 'closed')}>
            <GameHeader
                isOpen={isOpen}
                rows={rows}
                isExpanded={isExpanded}
                onToggleExpanded={setIsExpanded}
                gameType={GameType.BINGO}
                calculatePrice={calculatePrice}
                onEdit={() => toggleOpen()}
                deleteGame={deleteGame}
                isFinal={props.isFinal}
            ></GameHeader>
          {isOpen &&  <div className="whiteBgRounded marginBottom1">
                <div>
                {   createRows()}
                </div>
                {isOpen && <button disabled={rows.length === GameType.labels.length} className="button button--success bold marginBottom1 marginTop1 marginLeft1 roundSquare" onClick={(ele) => addRow(ele)}>{t('button.addRow')}</button>}
            </div>}
     
     
            <div className="stickyBar">
            {isOpen && <DrawCountSelector drawCount={drawCount} setDrawCount={setDrawCount}></DrawCountSelector>}
            {(!isOpen && rows.length < 1) && <GameStartButtons gameType={GameType.BINGO}></GameStartButtons>}
            {isOpen && <AddToCart gameType={GameType.BINGO} rows={rows} calculatePrice={calculatePrice} addToCart={addToCart}></AddToCart>}
            {/* !isOpen && rows.length > 0 && <div className="afterBorder05 marginLeft1 marginRight1"></div>*/}
        </div>
     
     
        </div>
    );
};

export default Bingo;
